import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchQualification, FETCH_QUALIFICATION} from "../../actions/student.action"

function* handleFetchQualification(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchQualification, action.payload);
    //extract the data here     
    yield put(fetchQualification.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchQualification.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchQualificationSaga() {
  yield takeLatest(FETCH_QUALIFICATION.REQUEST, handleFetchQualification);
}

export default fetchQualificationSaga;
